import * as React from 'react';
import { FormControl } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';

interface IFormSelectProps extends FormControl.FormControlProps {
    defaultTranslateKey?: string;
    autofocus?: boolean;
    defaultOptionValue?: any;
}

const FormSelect = (props: IFormSelectProps) => {
    const { defaultTranslateKey, defaultOptionValue, ...rest } = props;
    return (
        <div className="select-div">
            <FormControl componentClass="select" {...rest}>
                {props.defaultTranslateKey && (
                    <option value={props.defaultOptionValue ? props.defaultOptionValue : ''}>
                        {Translate(props.defaultTranslateKey)}
                    </option>
                )}
                {props.children}
            </FormControl>
        </div>
    );
};

export default FormSelect;
